import { hashKey, useQuery } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface FetchTemplatesEditFieldsResponse {
  additionalFixedValues: string[];
  mappingFields: string[];
  highValueSettings: {
    stakeholdersMapping: string[];
    shipmentsMapping: {
      mappingFields: string[];
    };
    othersMappings: string[];
  };
  batchMappings: {
    additionalFixedValues: string[];
    otherMappings: string[];
  };
}

export const useAdminTemplatesEditFields = (criteria: any) =>
  useQuery({
    queryKey: ['admin-templates-edit-fields', hashKey(criteria)],
    queryFn: async (): Promise<FetchTemplatesEditFieldsResponse> => {
      const { type } = criteria;

      try {
        return await request({
          path: `template/edit-fields?type=${type}`,
          method: 'GET',
          authenticate: true,
        });
      } catch (error) {
        showErrorToast(error, 'Failed to fetch templates');
      }
    },
  });
